import {
  consoleLogger,
  authenticationManager as manager,
} from '@tier4/webauto-auth-frontend-client';

const authenticationManager = manager({
  authority: import.meta.env.VITE_OIDC_PROVIDER_ENDPOINT,
  client_id: import.meta.env.VITE_OIDC_CLIENT_ID,
  client_secret: import.meta.env.VITE_OIDC_CLIENT_SECRET,
  redirect_uri: import.meta.env.VITE_OIDC_LOGIN_REDIRECT_URL,
  post_logout_redirect_uri: import.meta.env.VITE_OIDC_LOGOUT_REDIRECT_URI,
  tokenServiceAPIUrl: `https://${import.meta.env.VITE_AUTH_API_DOMAIN}`,
  automaticSilentRenew: true,
  revokeTokensOnSignout: true,
  loadUserInfo: true,
  logMethod: consoleLogger,
  logLevel: import.meta.env.VITE_OIDC_LOG_LEVEL,
  afterSignOutPropagation: () => {
    location.href = '/logout.html';
  },
});

authenticationManager.userManager.events.addSilentRenewError(async (e) => {
  console.error('Silent renew error:', e);
  await authenticationManager.userManager.removeUser();
  location.href = '/logout.html';
});

export default authenticationManager;
